import { request } from '@/api';
import type { MfaType } from './login';
import type { PurposeType } from './generate';

const PREFIX = '/auth/mfa';

/**
 * /code/send
 * 发送MFA验证码（用于已登录用户执行风险操作）
 * @param mfaType MFA类型
 * @param mfaPurpose 风险操作类型
 */
export const sendMfaRiskCode = (mfaType: MfaType, mfaPurpose: PurposeType) => {
  return request.post(`${PREFIX}/code/send`, {
    mfaType,
    mfaPurpose,
  });
};
